/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBellSlash: {
  name: 'bell-slash';
  data: string;
} = {
  name: 'bell-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.129 3.167A7 7 0 0 1 19 9v4.586l1.707 1.707a1 1 0 0 1-1.414 1.414L17.586 15A2 2 0 0 1 17 13.586V9a5 5 0 0 0-7.764-4.167 1 1 0 1 1-1.107-1.666ZM6 9a1 1 0 0 1 1 1v3.697a2 2 0 0 1-.336 1.11L5.87 16H12a1 1 0 1 1 0 2h-2a2 2 0 0 0 3.491 1.333 1 1 0 1 1 1.49 1.334A4 4 0 0 1 8 18H5.869c-1.598 0-2.55-1.78-1.665-3.11L5 13.698V10a1 1 0 0 1 1-1ZM4.707 3.293a1 1 0 0 0-1.414 1.414l16 16a1 1 0 0 0 1.414-1.414l-16-16Z" fill="currentColor"/></svg>`,
};
